import { render, staticRenderFns } from "./incubator.vue?vue&type=template&id=2efab73c&scoped=true&"
import script from "./incubator.vue?vue&type=script&lang=js&"
export * from "./incubator.vue?vue&type=script&lang=js&"
import style0 from "./incubator.vue?vue&type=style&index=0&id=2efab73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efab73c",
  null
  
)

export default component.exports